class CollapsibleTabDrawer extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.trigger = this.querySelector('.tab-drawer__trigger');
    this.overlay = this.querySelector('.tab-drawer__overlay');
    this.panel = this.querySelector('.tab-drawer__panel');
    this.closeButton = this.querySelector('.tab-drawer__close');

    if (!this.trigger || !this.overlay || !this.panel || !this.closeButton) return;

    this.handleKeydown = this.handleKeydown.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.trigger.addEventListener('click', this.open);
    this.closeButton.addEventListener('click', this.close);
    this.overlay.addEventListener('click', this.close);
    document.addEventListener('keydown', this.handleKeydown);
  }

  handleKeydown(e) {
    if (e.key === 'Escape' && this.panel.classList.contains('active')) {
      this.close();
    }
  }

getHeaderHeight() {
  var header = document.querySelector('sticky-header, .header-wrapper, header');

  if (!header) return 0;

  var rect = header.getBoundingClientRect();
  var style = window.getComputedStyle(header);

  var isFixed = style.position === 'fixed';

  var isActuallyVisibleAtTop =
    rect.bottom > 0 &&
    rect.top >= -2 &&
    rect.top <= 2;

  if (isFixed || isActuallyVisibleAtTop) {
    return header.offsetHeight;
  }

  return 0;
}

  open() {
    var headerHeight = this.getHeaderHeight();

    this.panel.style.top = headerHeight + 'px';
    this.panel.style.height = 'calc(100% - ' + headerHeight + 'px)';

    this.overlay.style.top = headerHeight + 'px';
    this.overlay.style.height = 'calc(100% - ' + headerHeight + 'px)';

    this.overlay.classList.add('active');
    this.panel.classList.add('active');
    document.body.classList.add('tab-drawer-open');

    var vitapuan = document.querySelector('#appstle-loyalty-button');
    if (vitapuan) vitapuan.style.display = 'none';
  }

  close() {
    this.overlay.classList.remove('active');
    this.panel.classList.remove('active');
    document.body.classList.remove('tab-drawer-open');

    if (this.trigger) this.trigger.focus();

    var vitapuan = document.querySelector('#appstle-loyalty-button');
    if (vitapuan) vitapuan.style.display = '';
  }
}

if (!customElements.get('collapsible-tab-drawer')) {
  customElements.define('collapsible-tab-drawer', CollapsibleTabDrawer);
}